import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowCornerRightUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowCornerRightUp"><Path fillRule="evenodd" clipRule="evenodd" d="M4 19.4142H14V6.82843L11 9.82843L9.58579 8.41421L15 3L20.4142 8.41421L19 9.82843L16 6.82843V21.4142H4V19.4142Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowCornerRightUp;
